import { PkDivider } from '@uefadigital/panenka-react';
import useThrottledCallback from 'beautiful-react-hooks/useThrottledCallback';
import useWindowScroll from 'beautiful-react-hooks/useWindowScroll';
import clsx from 'clsx';
import { memo, useRef, useState } from 'react';

import { useLivescoresOptions } from '../../store';
import CalendarTabs from '../CalendarTabs';
import DatesList from '../DatesList';
import Header from '../Header';

import * as styles from './styles.module.scss';

const Main = () => {
  const { options } = useLivescoresOptions();
  const onWindowScroll = useWindowScroll();
  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  onWindowScroll(
    useThrottledCallback(
      () => {
        if (!headerRef.current) return;

        const sticky = headerRef.current.offsetTop > headerRef.current.getBoundingClientRect().top;
        setIsSticky(sticky);
      },
      [],
      100,
    ),
  );

  return (
    <>
      <div
        className={clsx(
          'pk-container',
          'pk-bg--background',
          options.headerTheme === 'light' && 'pk-border-bottom',
          'pk-pb--m',
          isSticky && 'pk-pt--m pk-pt-md--l',
          styles.header,
          styles.headerSticky,
          options.cssClass,
        )}
        ref={headerRef}
        pk-theme={options.headerTheme}
      >
        <Header isSticky={isSticky} />
        <PkDivider
          className={clsx('pk-col pk-col--span-12 pk-d-md--none', styles.divider, isSticky ? 'pk-my--0' : 'pk-my--xs')}
        />
        <div className={clsx(styles.tabsContainer, 'pk-col pk-col--span-12')}>
          <CalendarTabs />
        </div>
      </div>
      <div className='pk-container pk-bg--background pk-position--relative' pk-theme='light'>
        <DatesList />
      </div>
    </>
  );
};

export default memo(Main);
